import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const propTypes = {
  active: PropTypes.bool
};

const defaultProps = {
  active: false
};

const Select = ({ children, active, ...props }) => (
  <Wrapper $active={active} {...props}>
    {children}
  </Wrapper>
);

/**
 * styles
 */
const Wrapper = styled.div`
  padding: 1rem;
  cursor: pointer;
  user-select: none;
  border-radius: 2px;
  transition: ease-in-out 0.15s all;
  background: ${({ $active }) =>
    $active ? "var(--bs-gray-10)" : "var(--bs-white)"};
  border: solid 1px
    ${({ $active }) => ($active ? "var(--bs-gray)" : "var(--bs-gray-20)")};

  .card__desc {
    color: ${({ $active }) => ($active ? "var(--bs-black)" : "var(--bs-gray)")};
  }

  @media (min-width: 768px) {
    padding: 1rem 1.5rem;
  }
`;

Select.propTypes = propTypes;
Select.defaultProps = defaultProps;

export default Select;
